<template>
    <a class="action left go-back-button" href="#" ref="goBackButtonElement">
        <i class="fal fa-arrow-left"></i>
    </a>
</template>

<script setup lang="ts">
    import { Ripple } from "@/shared/ui/Ripple";
    import { onMounted, ref } from "vue";

    const goBackButtonElement = ref<HTMLElement | null>(null);

    onMounted(() => {
        Ripple.bind($(goBackButtonElement.value!));
    });
</script>
